<template>
	<div class="timeline-item">
		<div class="item">
			<span :style="getBackgroundColour(itemTimeline.color)" class="dot" />
			<div class="activity-created d-flex align-items-center">
				
				<span :title="getFormattedDate(itemTimeline.date_created, 'full')">
					{{ getFormattedDate(itemTimeline.date_created) }}
					<span v-if="itemTimeline.user"> by <i>{{ getUser(itemTimeline.user) }}</i></span>
				</span>
				
			</div>

			<div class="activity">
				<!-- <div>
					<p class="activity-type">{{ itemTimeline.note_type }}</p>
					<span class="activity-details">{{ itemTimeline.note_details }}</span>
				</div>

				<div>
					<textarea class="activity-update" :value="itemTimeline.note_details"></textarea>
				</div> -->
				
				<slot name="activity"></slot>
			</div>

			<div class="activity-updated" v-if="itemTimeline.date_created != itemTimeline.date_updated">
				<span :title="getFormattedDate(itemTimeline.date_updated, 'full')">
					Edited: {{ getFormattedDate(itemTimeline.date_updated, 'full') }}
				</span>
			</div>
      
		</div>
   </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TimelineItem',

  props: {
    itemTimeline: {
      type: Object,
      default: () => ({})
    },
    colorDots: {
      type: String,
      default: '#2da1bf'
    },
    dateLocale: {
      type: String,
      default: ''
    }
  },

  methods: {
   getBackgroundColour(color) {
		return color ? `background:${color}` : `background:${this.colorDots}`
   },
	getUser(user) {
		return user.firstName + " " + user.lastName
	},
	getFormattedDate(date, type){
		if (type == "full") {
			return moment(date).format("MMMM DD, YYYY h:mm A")
		} else {
			return moment(date).format("DD MMMM")
		}
		
	},
  }
}
</script>

<style scoped>
.timeline-item .item {
	border-left: 5px solid #ccd5db;
	padding: 20px 0 20px 15px;
	position: relative;
	font-size: 14px;
	/* width: fit-content; */
}

.timeline-item .activity-created {
	min-width: 150px;
	width: fit-content;
	height: 22px;
	border-radius: 5px 5px 5px 0px;
	background: #435666;
	/* padding: 5px; */
	padding: 0 0.5rem;
	/* position: fixed; */
	
}

.timeline-item .activity-created span {
	color: #FFF;
	/* padding: 0 0.5rem; */
	/* font-size: 14px; */
}

.timeline-item .activity {
	border-radius: 0px 5px 5px 5px;
	border: 1px solid #435666;
	padding: 1rem;
	margin-top: -10px;
}

.timeline-item :slotted(.activity-title) {
	/* padding-bottom: 1rem; */
	color: #435666;
	font-weight: 900;
	margin: 10px 0;
}

.timeline-item :slotted(.activity-details) {
	/* font-weight: 100; */
	margin: 0;
	/* padding-top: 1rem; */
}

.timeline-item .dot {
	display: block;
	position: absolute;
	width: 13px;
	height: 13px;
	border-radius: 50%;
	left: -9px;
	top: 22px;
}

.timeline-item .activity-updated{
	padding-top: 0.5rem;
	color: #435666;
	font-size: 12px;
	font-style: italic;
}
</style>